module.exports = __webpack_public_path__ + "media/images/sandbox/sonic--thumb-65a1b3dd03d403c8b2d2731bda15675a.png";